import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Space } from 'antd';

const LinkWithIcon = ({ to, children, iconStyle }) => {
  return (
    <Link to={to}>
      <Space>
        {children}
        <ArrowRightOutlined style={{ fontSize: '14px', color: '#1890ff', transform: 'rotate(-45deg)', ...iconStyle }} />
      </Space>
    </Link>
  );
};

export default LinkWithIcon;
